module.exports = __webpack_public_path__ + "img/free1.68810b24.png";